module.exports = __webpack_public_path__ + "images/category_lp/common/icon-company-3_e3a8688ee22e65d26bb0e71f9f0a7b1f.png";